import { type FileType } from '@/types/uploadFiles';

export type CreateLeasingProps = FirstTabType & SecondTabType;

type FirstTabType = MainInfoInterface & {
  vehicles: VehicleInterface[];
} & GeneralInformationInterface;

type SecondTabType = ContactsInfoInterface &
  ManagerInformationInterface &
  FinanceFormInterface;

// --------------------------------------
// First Tab Types ->

interface MainInfoInterface {
  leasingAmount: number | string;
  initialPayment: number | string;
  leasingPeriod: number | string;
}

interface VehicleInterface {
  info?: {
    brand: { uuid: string; name: string };
    model: { uuid: string; name: string };
    year: string;
  };
  price: string;
  count: string;
}

interface GeneralInformationInterface {
  iin: string;
  companyName: string;
  bankDetails: string;
  oked: string;
  jobType: string;
  country: string;
  legalAddress: string;
  typeOfProperty: string;
  registrationPlace: string;
  registrationNumber: string;
  registrationDate: string;
  startWork: string;
  license: string;
  licenseDescription: string;
  licenseNumber: string;
}

// --------------------------------------
// Second Tab Types ->

interface ContactsInfoInterface {
  fullName: string;
  phone: string;
  email: string;
}

interface ManagerInformationInterface {
  managerName: string;
  managerDocument: string;
  managerDocumentNumber: string;
  managerDocumentIssueDate: string;
  managerDocumentEndDate: string;
}

interface FinanceFormInterface {
  balanceSheet?: FileType;
  statement?: FileType;
  financeReport?: FileType;
  fno?: FileType;
  creditHistory?: FileType;
  ocStatement?: FileType;
  additionalDocuments?: FileType[];
}
